import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import OpenTofuMigrationStateBadge from "shared/Stack/OpenTofuMigration/StateBadge";
import { OpenTofuMigrationQueueEntryNode } from "shared/Stack/OpenTofuMigration/gql";

const OpenTofuMigrationQueueTableStateCell = ({
  item: entry,
  ...cellProps
}: TableSimpleCellProps<OpenTofuMigrationQueueEntryNode>) => (
  <TableSimpleCell {...cellProps}>
    <OpenTofuMigrationStateBadge
      state={entry.state}
      vendorConfigTypename={entry.stack.vendorConfig?.__typename}
    />
  </TableSimpleCell>
);

export default OpenTofuMigrationQueueTableStateCell;
